
export const getIgnoringQueryObject = (ignoredUserGroupIds: string[], returnValue = null) => {
    return ignoredUserGroupIds ? { groupIds: { $notContainsAny: ignoredUserGroupIds } } : returnValue;
}